import api from '../../../services/api';

export function getNeighborhoods({ userPermission, additionalProps = {}, where = {}, callback = console.log }) {
    api.get(`${userPermission}/neighborhoods?filter=${JSON.stringify({ ...additionalProps, where })}`).then(response => {
        let names = [];
        response.data.forEach(item => {
            names.push(item.name)
        });

        callback(names);
    });
}

export function getServices({ callback = console.log }) {
    api.get(`complaint-categories`).then(response => {
        let names = [];
        response.data.forEach(item => {
            names.push(item.target)
        });

        callback(names);
    });
}

export function getExecutors({ userPermission, additionalProps = {}, where = {}, callback = console.log }) {
    api.get(`${userPermission}/complaints?filter=${JSON.stringify({ ...additionalProps, where })}`).then(response => {
        let names = [];

        response.data.forEach((item) => {
            if (item.executorName)
                if (!names.includes(item.executorName))
                    names.push(item.executorName)
        });

        callback(names);
    });
}

export function getControladores({ userPermission, additionalProps = {}, where = {}, callback = console.log }) {
    api.get(`${userPermission}/complaints?filter=${JSON.stringify({ ...additionalProps, where })}`).then(response => {
        let names = [];

        response.data.forEach((item) => {
            if (item.controladorName)
                if (!names.includes(item.controladorName))
                    names.push(item.controladorName)
        });

        callback(names);
    });
}

export function getAreas({ userPermission, additionalProps = {}, where = {}, callback = console.log }) {
    //Se o usuário for um administrador ele terá acesso a todas as areas
    if (userPermission === 'admin') {
        api.get(`${userPermission}/areas?filter=${JSON.stringify({ ...additionalProps, where })}`).then(response => {
            let arr = [];
            for (let item of response.data)
                arr.push(item.name);

            callback(arr);
        });

    } else {//Caso contrário, ele terá acesso somente as quais foram lhe atribuídas no cadastro
        api.get(`/profile?filter=${JSON.stringify({ ...additionalProps, where })}`).then(response => {
            callback(response.data.areas);
        });
    }
}

//Se o valor de algum campo no filtro for "Todos" (case insensitive) ou nulo, este filtro será desconsiderado
export function getComplaints({ userPermission, additionalProps = {}, where = {}, callback = console.log }) {

    Object.keys(where).forEach((key) => {
        if (!where[key])
            where[key] = undefined;

        if (typeof where[key] === 'string' && where[key].toUpperCase() === "TODOS") {
            where[key] = undefined;
        }
    });

    return api.get(`${userPermission}/complaints?filter=${JSON.stringify({ ...additionalProps, where })}`)
        .then((res) => callback(res.data));
}